export default __webpack_public_path__ + "static/media/mapPinCafe.120216fa.svg";